import JsLoader from "If_AdTool/common/JsLoader";
import funListLimit from "./funListlimit";
import Elshow from "If_AdTool/common/Elshow";
var elShow = new Elshow(200, 200);
/***
 * 当前页面容许最大重试次数
 * **/
const PageMaxRetryNum = 4;
/***
 * 当前页面容许重试次数
 * **/
let PageRetryNum = 0;

const MaxRetryNum = 1;

let baseTxtArr = [
    { "href": "http://tech.ifeng.com/lab/", "txt": "来凤凰网科技看最潮流的产品指南" },
    { "href": "https://ncar.auto.ifeng.com/photo/home", "txt": "了解最新汽车资讯就来凤凰网汽车" },
    { "href": "https://mil.ifeng.com/", "txt": "凤凰网军事平台为您提供全方位军事话题" },
    { "href": "https://news.ifeng.com/", "txt": "来凤凰网获取全球最新资讯" },
    { "href": "https://finance.ifeng.com/", "txt": "凤凰网财经——离用户最近的财经媒体" },
    { "href": "https://sports.ifeng.com/", "txt": "到凰家看台，聊最新体育赛事" },
    { "href": "https://tech.ifeng.com/", "txt": "凤凰网科技——直击真相的科技媒体" },
    { "href": "https://fo.ifeng.com/zonghe/special/lghsqqq/", "txt": "凤凰网佛教——两个和尚锵锵锵" },
    { "href": "https://finance.ifeng.com/", "txt": "凤凰网财经——全球主流财经门户" },
    { "href": "https://finance.ifeng.com/lifeplus/index.shtml", "txt": "生活美学家——生活美学享品质生活" },
]
export default function baiduAd(adData, el) {
    let { loadBaiduLib = false} = window.IfengAmgr;
    if (!loadBaiduLib) {
        JsLoader("//cpro.baidustatic.com/cpro/ui/c.js", () => {
            window.IfengAmgr.loadBaiduLib = true;
            loadBaiduAd(adData, el);
        })
    } else {
       loadBaiduAd(adData, el);
    }
}
//重新加载百度广告
function retryLoadBaiduAd(adData){
    setTimeout(function(){
        adData.retryNum++;
        loadOneBaiduAd(adData);
    },1000)
   
}
/***
 * 加载一个百度广告
 * ****/
function loadOneBaiduAd(adData){
    let {
        el,
        tuid,//百度 tuid
        adEl=null,
        w,//宽
        h, //高
        type,
        rem = false,
        closeFn = null,
        bFontSize = 14,//基础 FontSize
        visibleRender = false,
        dTxt = false,//是否展示铺底文字
        dstyle = "",//铺底文字样式
        retryNum=0//重试次数
    } = adData;
    if (window.location.href.indexOf("#showAdBox") != -1) {
        el.style.border = "1px solid green";
    }
    let {  BaiduRun = null } = window.IfengAmgr;
    if (BaiduRun == null) {
        window.IfengAmgr.BaiduRun = new funListLimit(1000, 30);
    }
    if (adEl==null){
        adEl = document.createElement("div");
        if (el){
            el.appendChild(adEl);
        }else{
           console.error("发生异常");
           closeFn && closeFn() 
           return;
        }
    }else{
        adEl.innerHTML= ""; 
    }
    if (rem){
        remHandler(adEl, adData)
    }
    let { top } = el.getBoundingClientRect();
    window.IfengAmgr.BaiduRun.add(function () {
        if (window.location.href.indexOf("#showAdBox") != -1) {
            el.style.border = "1px solid red";
        }
        let { baiduElTuidMap = {}, baiduTuidKeyMap = {}} = window.IfengAmgr;
        let css = "_" + Math.random().toString(36).slice(2);
        adEl.className = css;
        adEl.style.overflow = "hidden";
        if (!baiduTuidKeyMap.hasOwnProperty(tuid)) {
            baiduTuidKeyMap[tuid] = 0;
        } else {
            baiduTuidKeyMap[tuid]++;
        }
        let key = tuid + "_" + baiduTuidKeyMap[tuid];
        baiduElTuidMap[key] = {
            num: baiduTuidKeyMap[tuid],//
            el,//广告外层容器
            adEl,//百度广告容器  
            tuid,//百度 tuid
            w,//宽
            h, //高
            rem,
            type,
            retryNum,//重试次数
            closeFn,
            bFontSize,//基础 FontSize
            visibleRender,
            dTxt,//是否展示铺底文字
            dstyle//铺底文字样式
        };
        console.log("baiduElTuidMap", baiduElTuidMap);
        window.IfengAmgr.baiduElTuidMap = baiduElTuidMap;
        window.IfengAmgr.baiduTuidKeyMap = baiduTuidKeyMap;
        
        (window.slotbydup = window.slotbydup || []).push({
            id: tuid,
            container: css,
            async: true
        });
    }, top);
    return adEl;
}
//无广告处理
function setNoAdFun(){
    let { isSetNoAd = false } = window.IfengAmgr;
    if (!isSetNoAd) {
        window.IfengAmgr.isSetNoAd = true;
        (window.slotbydup = window.slotbydup || []).push({
            // 广告关闭回调方法 一个页面只需要定义一个
            closeAd: function (tu_index) {
                let { baiduElTuidMap = {} } = window.IfengAmgr;
                let adData = baiduElTuidMap[tu_index];
                if (adData) {
                    let adEl = adData.adEl;
                    adEl.style.display = "none";
                    adData.closeFn && adData.closeFn()
                }
            },
            noAd: function (tu_index, noadInfo) {
                let { baiduElTuidMap = {} } = window.IfengAmgr;
                let adData = baiduElTuidMap[tu_index];
                console.log("无广告", tu_index, noadInfo, baiduElTuidMap, adData)
                //重新加载广告
                if (adData) {
                    //delete baiduElTuidMap[tu_index];//删除此map,避免重复处理
                    let retryNum = adData.retryNum;
                    if (MaxRetryNum <= retryNum || PageRetryNum > PageMaxRetryNum){
                        let adEl = adData.adEl;
                        if (adData.type == "txt" && adData.dTxt) {
                            let index = Math.floor(Math.random() * baseTxtArr.length);
                            let item = baseTxtArr[index];
                            adData.el.innerHTML = `<a href="${item.href}" style="${adData.dstyle}" target="_blank">${item.txt}</a>`
                        } else {
                            if (window.location.href.indexOf("#showAdBox") != -1) {
                                adEl.style.border = "1px solid blue";
                            }
                            adEl.style.display = "none";
                            adData.closeFn && adData.closeFn()
                        }
                    }else{
                        //重试
                        console.log("开始重试百度广告,");
                        retryLoadBaiduAd(adData)
                    }
                    PageRetryNum++;
                }
            }
        })
    }
}
/**
 * rem渲染
 * ***/
function remHandler(div, opt){
    let {
        w,
        h,
        el,
        type,
        bFontSize
    }=opt;
    let fontSize = document.getElementsByTagName('html')[0].style.fontSize;
    fontSize = parseFloat(fontSize) || 14;
    let scale = fontSize / bFontSize;
    div.style.transformOrigin = "left top";
    div.style.transform = "scale(" + fontSize / bFontSize + ")";
    if (scale == 1) {
        if (type == "txt") {
            div.style.width = "calc(100% - 28px)";
            div.style.height = "100%";
        } else {
            div.style.width = "100%";
            div.style.height = "100%";
        }
    } else {
        let elW = el.offsetWidth;
        let elh = el.offsetHeight;
        if (elW && elh && elW < w * scale) {
            el.style.overflow = "hidden";
        }
        if (type == "txt") {
            let fscale = 100 / scale;
            div.style.width = "calc(" + fscale +"% - 28px)";
            div.style.height = "100%";
        } else {
            div.style.width = `${w}px`;
            div.style.height = `${h}px`;
        }
    }
}

function loadBaiduAd(adData, el) {
    let {
        tuid,//百度 tuid
        w,//宽
        h, //高
        rem = false,
        closeFn = null,
        renderOk =null,
        bFontSize = 14,//基础 FontSize
        visibleRender = false,
        dTxt = false,//是否展示铺底文字
        dstyle = ""//铺底文字样式
    } = adData;
    let type = "img";
    if (w == "1" || h == "1") {
        type = "txt";
    }
    //设置没广告
    setNoAdFun();
    let baiduOpt = {
        el,//el
        tuid,//百度 tuid
        w,//宽
        h, //高
        type,//类型
        rem,//是否是rem页面
        closeFn,//关闭页面
        renderOk,//渲染成功
        bFontSize,//基础 FontSize
        visibleRender,//是否可见曝光
        dTxt,//是否展示铺底文字
        dstyle//铺底文字样式
    }
    //可见渲染
    if (visibleRender) {
        elShow.listenerScroll(el, () => {
            let div = loadOneBaiduAd(baiduOpt);
            renderOk && renderOk(div)
        })
    } else {
        let div = loadOneBaiduAd(baiduOpt);
        renderOk && renderOk(div)
    }
}